// src/components/layout/AdminPortalLayout.tsx
import React, { useEffect, useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar/Sidebar';
import AdminHeader from './AdminHeader/AdminHeader';
import styles from './AdminPortalLayout.module.css';
import { useAuth } from '../../context/AuthContext';

const STORAGE_KEY = 'admin_sidebar_open';

const AdminPortalLayout: React.FC = () => {
  const { user } = useAuth();
  const initialOpen = useMemo(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'true') return true;
    if (saved === 'false') return false;
    return window.innerWidth > 992;
  }, []);

  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(initialOpen);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, String(isSidebarOpen));
  }, [isSidebarOpen]);

  const toggleSidebar = () => setIsSidebarOpen(prev => !prev);

  return (
    <div className={styles.layout}>
      <Sidebar
        userRole={user?.role || 'admin'}
        isOpen={isSidebarOpen}
        onLinkClick={() => {
          if (window.innerWidth < 992) setIsSidebarOpen(false);
        }}
      />

      <div className={`${styles.main} ${isSidebarOpen ? styles.mainShifted : ''}`}>
        <AdminHeader onMenuToggle={toggleSidebar} />
        <main className={styles.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminPortalLayout;
